<template>
  <div class="container">
    <table class="table table-striped" style="border: 1px solid #000;">
      <thead>
        <tr>
          <th scope="col" colspan="2">Causales</th>
          <th scope="col">{{ Yeartwo }}</th>
          <th scope="col">{{ YearOne }}</th>
          <th scope="col">{{ varEntorno }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row" colspan="2">{{ textOne }}</th>
          <td><input   :disabled="readOnly" class="input" v-model="ceseRetiro.inputOne" /></td>
          <td><input   :disabled="readOnly" class="input" v-model="ceseRetiro.inputTwo" /></td>
          <td><input   :disabled="readOnly" v-model="ceseRetiro.inputThree" class="input" /></td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textTwo }}</th>
          <td><input   :disabled="readOnly" v-model="ceseRetiro.inputFour" class="input" /></td>
          <td><input   :disabled="readOnly" v-model="ceseRetiro.inputFive" class="input" /></td>
          <td><input   :disabled="readOnly" v-model="ceseRetiro.inputSix" class="input" /></td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textThree }}</th>
          <td><input   :disabled="readOnly" class="input" v-model="ceseRetiro.inputSeven" /></td>
          <td><input   :disabled="readOnly" class="input" v-model="ceseRetiro.inputEight" /></td>
          <td><input   :disabled="readOnly" v-model="ceseRetiro.inputNine" class="input" /></td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textFour }}</th>
          <td><input   :disabled="readOnly" v-model="ceseRetiro.inputTen" class="input" /></td>
          <td><input   :disabled="readOnly" v-model="ceseRetiro.inputEleven" class="input" /></td>
          <td><input   :disabled="readOnly" v-model="ceseRetiro.inputTwelve" class="input" /></td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textFive }}</th>
          <td><input   :disabled="readOnly" class="input" v-model="ceseRetiro.inputThirteen" /></td>
          <td><input   :disabled="readOnly" class="input" v-model="ceseRetiro.inputFourteen" /></td>
          <td><input   :disabled="readOnly" v-model="ceseRetiro.inputFifteen" class="input" /></td>
        </tr>
        <tr>
          <th scope="row" colspan="2">{{ textSix }}</th>
          <td>
            {{ totalOne }}
          </td>
          <td>
            {{ totalTwo }}
          </td>
          <td>
            {{ totalThree }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import store from "../../../../../store";

export default {
  components: {},
  props: ["ceseRetiro", "readOnly"],
  data() {
    return {
      textOne: "Funcionarios jubilados año t",
      textTwo: "Funcionarios fallecidos año t",
      textThree: "Retiros voluntarios con incentivo al retiro año t",
      textFour: "Otros retiros voluntarios año t",
      textFive: "Funcionarios retirados por otras causales año t",
      textSix: "Total de ceses o retiros",
      varEntorno: `${process.env.VUE_APP_ANIO}`,
      YearOne: "",
      Yeartwo: "",
      YearThre: "",
      data: "1",
      dataTwo: "2",
      inputOne: 0,
      inputTwo: 0,
      inputThree: 0,
      inputFour: 0,
      inputFive: 0,
      inputSix: 0,
      inputSeven: 0,
      inputEight: 0,
      inputNine: 0,
      inputTen: 0,
      inputEleven: 0,
      inputTwelve: 0,
      inputThirteen: 0,
      inputFourteen: 0,
      inputFifteen: 0,
      totalOne: 0,
      totalTwo: 0,
      totalThree: 0,
      porcentaje: "100",
    };
  },
  mounted() {
    this.YearOne = parseInt(this.varEntorno) - parseInt(this.data);
    this.Yeartwo = parseInt(this.varEntorno) - parseInt(this.dataTwo);
  },
  updated() {
    // Primer Suma
    this.totalOne =
      parseInt(this.ceseRetiro.inputOne) +
      parseInt(this.ceseRetiro.inputFour) +
      parseInt(this.ceseRetiro.inputSeven) +
      parseInt(this.ceseRetiro.inputThirteen) +
      parseInt(this.ceseRetiro.inputTen);
    //Segunda Suma
    this.totalTwo =
      parseInt(this.ceseRetiro.inputTwo) +
      parseInt(this.ceseRetiro.inputFive) +
      parseInt(this.ceseRetiro.inputEight) +
      parseInt(this.ceseRetiro.inputEleven) +
      parseInt(this.ceseRetiro.inputFourteen);
    //Tercera Suma
    this.totalThree =
      parseInt(this.ceseRetiro.inputThree) +
      parseInt(this.ceseRetiro.inputSix) +
      parseInt(this.ceseRetiro.inputNine) +
      parseInt(this.ceseRetiro.inputTwelve) +
      parseInt(this.ceseRetiro.inputFifteen);

    // store.dispatch("rHumanos/actionsTable", {
    //   value: [
    //     {
    //       title: this.textOne,
    //       anioTwo: this.inputOne,
    //       anioOne: this.inputTwo,
    //       anio: this.inputThree,
    //     },
    //     {
    //       title: this.textTwo,
    //       anioTwo: this.inputFour,
    //       anioOne: this.inputFive,
    //       anio: this.inputSix,
    //     },
    //     {
    //       title: this.textThree,
    //       anioTwo: this.inputSeven,
    //       anioOne: this.inputEight,
    //       anio: this.inputNine,
    //     },
    //     {
    //       title: this.textFour,
    //       anioTwo: this.inputTen,
    //       anioOne: this.inputEleven,
    //       anio: this.inputTwelve,
    //     },
    //     {
    //       title: this.textFive,
    //       anioTwo: this.inputThirteen,
    //       anioOne: this.inputFourteen,
    //       anio: this.inputFifteen,
    //     },
    //     {
    //       title: this.textSix,
    //       anioTwo: this.inputThirteen,
    //       anioOne: this.totalTwo,
    //       anio: this.totalThree,
    //     },
    //   ],
    //   nameTable: "ceseRetiro",
    // });
  },
};
</script>

<style scoped>
th {
  text-align: left !important;
  font-size: 14px !important ;
}



.div {
  border: 1px solid #000;
  width: 96%;
  height: 26px;
  position: relative;
  left: 3px;
  background-color: #fff;
}
</style>
